import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";

import AddScheduledEvent from "./Forms/AddScheduledEvent/AddScheduledEvent";
import EditScheduledEvent from "./Forms/EditScheduledEvent/EditScheduledEvent";
import DetailsEvent from "./Forms/DetailsEvent/DetailsEvent";
import DeleteScheduledEvent from "./Forms/DeleteScheduledEvent/DeleteScheduledEvent";
import TransitionModal from "../../../components/UI/Modal/Modal";
import EnhancedTable from "../../../components/UI/Table/Table";
import { firestore } from "../../../firebase";
import * as actions from "../../../store/actions";

const headCells = [
    {id: 'name', label: 'Event Name'},
    {id: 'date', label: 'Date (Y-M-D)',},
    {id: 'start', label: 'Start Time', time: true},
    {id: 'end', label: 'End Time', time: true}
];

const ScheduledEventList = (props) => {
    const {status} = props;
    const [editOpen, setEditOpen] = useState(false);
    const [addOpen, setAddOpen] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [detailsOpen, setDetailsOpen] = useState(false);
    const [disableSignUp, setDisableSignUp] = useState(false);
    const [formData, setFormData] = useState({});
    const [tableData, setTableData] = useState([]);
    const [eventList, setEventList] = useState([]);

    async function getEvents() {
        let events = [];
        const eventsRef = await firestore.collection('events')
            .get();
        eventsRef.forEach((event) => {
            events.push({...event.data(), id: event.id});
        });
        setEventList(events);
    }

    useEffect(() => {
        getEvents()
            .catch(error => {
                console.log(error)
            });
    }, []);

    async function getScheduledEvents() {
        let events = [];
        const eventsRef = await firestore.collection('scheduledEvents')
            .orderBy("date", "desc")
            .orderBy("start", "desc")
            .get();
        eventsRef.forEach((event) => {
            events.push({...event.data(), id: event.id});
        });
        setTableData(events);
    }

    useEffect(() => {
        getScheduledEvents()
            .catch(error => {
                console.log(error)
            });
    }, []);

    useEffect(() => {
        setDisableSignUp(status);
    }, [status]);
    //add modal functions
    function addEvent(scheduledEvent) {
        let tempTableData = [...tableData].concat(scheduledEvent)
            .sort((a, b) => {
                if (a.date === b.date) {
                    return a.start < b.start ? 1 : -1;
                }
                return a.date < b.date ? 1 : -1;
            });
        setTableData(tempTableData);
        handleAddClose();
    }

    const handleAddOpen = () => {
        setAddOpen(true);
    };

    const handleAddClose = () => {
        setAddOpen(false);
    };

    //edit modal functions
    function editEvent(scheduledEvent) {
        let tempTableData = [...tableData];
        const index = tableData.findIndex((event) => event.id === scheduledEvent.id);
        tempTableData[index] = scheduledEvent;
        setTableData(tempTableData);
        handleEditClose();
    }

    const handleEditOpen = (props) => {
        setFormData({...props});
        setEditOpen(true);
    };

    const handleEditClose = () => {
        setEditOpen(false);
    };

    //delete modal functions
    function deleteEvent({id}) {
        firestore.collection('scheduledEvents')
            .doc(id)
            .delete()
            .then(() => {
                firestore.collectionGroup("volunteerEvents")
                    .where("scheduledEventId", "==", id)
                    .get()
                    .then(function (result) {
                        result.forEach(row => {
                            row.ref.delete()
                                .catch(error => console.log(error));
                        });
                    });
            })
            .then(() => {
                const tempTableData = tableData.filter((event) => event.id !== id);
                setTableData(tempTableData);
            })
            .catch(error => {
                console.log(error)
            });
        handleDeleteClose();
    }

    const handleDeleteOpen = (props) => {
        setFormData({...props});
        setDeleteOpen(true);
    };

    const handleDeleteClose = () => {
        setDeleteOpen(false);
    };

    //details modal functions
    const handleDetailsOpen = (props) => {
        setFormData({...props});
        setDetailsOpen(true);
    };

    const handleDetailsClose = () => {
        setDetailsOpen(false);
    };

    //disable signup functions
    const handleSwitch = () => {
        setDisableSignUp(prevState => {
            const newState = !prevState;
            props.updateSignUpStatus(newState);
            return newState;
        });
    };

    const switchLabel = disableSignUp ? "Enable User Signup" : "Disable User Signup";

    return (
        <Container component="main" maxWidth="md" style={{textAlign: 'center'}}>
            <Typography variant="h3">Schedule Event Page</Typography>
            <EnhancedTable
                data={tableData}
                headCells={headCells}
                delete={handleDeleteOpen}
                add={handleAddOpen}
                edit={handleEditOpen}
                details={handleDetailsOpen}
                handleSwitch={handleSwitch}
                switchLabel={switchLabel}
                switchValue={disableSignUp}
            />
            <TransitionModal
                open={editOpen}
                handleOpen={handleEditOpen}
                handleClose={handleEditClose}
                form={<EditScheduledEvent formData={formData}
                                          onEdit={editEvent}
                                          eventList={eventList}
                                          handleClose={handleEditClose}/>}
                title={"Edit Scheduled Event"}
            />
            <TransitionModal
                open={addOpen}
                handleOpen={handleAddOpen}
                handleClose={handleAddClose}
                form={<AddScheduledEvent onAdd={addEvent}
                                         eventList={eventList}
                                         handleClose={handleAddClose}/>}
                title={"Schedule Event"}
            />
            <TransitionModal
                open={deleteOpen}
                handleOpen={handleDeleteOpen}
                handleClose={handleDeleteClose}
                form={<DeleteScheduledEvent formData={formData}
                                            submit={deleteEvent}
                                            cancel={handleDeleteClose}/>}
                title={"Are You Sure?"}
            />
            <TransitionModal
                open={detailsOpen}
                handleOpen={handleDetailsOpen}
                handleClose={handleDetailsClose}
                form={<DetailsEvent formData={formData} close={handleDetailsClose}/>}
                title={"Details"}
            />
        </Container>
    );
};

const mapDispatchToProps = dispatch => {
    return {
        updateSignUpStatus: (status) => dispatch(actions.updateSignUpStatus(status))
    }
};

const mapStateToProps = state => {
    return {
        status: state.signUp.status
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScheduledEventList);
